<template>
  <div class="class">
    <van-row>
      <van-col span="6">
        <van-sidebar
          v-model="activeKey"
          class="side"
        >
          <van-sidebar-item
            v-for="v in oneclass"
            :key="v.id"
            :title="v.name"
             v-show="v.name.indexOf('活动') ==-1"
            @click="changeclass(v)"
          />
        </van-sidebar>
      </van-col>
      <van-col
        span="18"
        offset="0"
      >
        <div class="title">
          <van-row>
            <van-col span="8">
              <div class="lhr"></div>
            </van-col>
            <van-col span="8">
              <p style="overflow: hidden;">{{name}}</p>
            </van-col>
            <van-col span="8">
              <div class="rhr"></div>
            </van-col>
          </van-row>
        </div>
        <ul>
          <li
            v-for="v in twoclass"
            :key="v.id"
            @click="goproduct(v.id,v.name)"
            v-show="[1115,1620,1727,1781,1842,1877,2047,2165,2061,1976,2058,2065,3628,3664,3686,3673,3675,3693,3701].indexOf(v.id) ==-1"

          >

            <div class="img">
              <img
                :src="v.thumb"
                alt=""
              >
            </div>
            <p>{{v.name}}</p>
          </li>

        </ul>
      </van-col>
    </van-row>
    <div
      class="load"
      v-show="load"
    >
      <van-loading />
      <van-loading
        type="spinner"
        color="#1989fa"
      />
    </div>
   <div class=" mim" v-show="showa">
      <div class="mi" >
        <p>请输入密码浏览</p>
        <input
          type="text"
          v-model="value"
        >
      </div>

      <div class="but">
        <van-button
          type="primary"
          size="large"
          @click="ok"
        >确认</van-button>
      </div>
    </div>
    
  </div>
</template>
<script>
import Vue from 'vue';
import { Sidebar, SidebarItem, Col, Row, Loading, Toast ,Popup,Button,} from 'vant';

Vue.use(Sidebar).use(SidebarItem).use(Row).use(Col).use(Loading).use(Popup).use(Button);
export default {
  created () {
    this.axios.get("categoryList", { params: { store_id: this.$store.state.shopid ,is_dis:1} }).then(res => {
      this.oneclass = res.data.data.list
      this.name = res.data.data.list[0].name
      this.twoclass = res.data.data.son_list
    }).catch(ref => {
      // console.log(res)
    })
   
  //  this.$store.state.pid=0
 this.$store.state.spid=0
      this.$store.state.spid1=""

  },
  data () {
    return {
      activeKey: 0,
      oneclass: [],
      twoclass: [],
      name: "",
      load: false,
      showa:false,
      value:''
    }
  },
  methods: {
    changeclass (v) {
      this.load = true
      this.name = v.name
      this.axios.get("categoryList", { params: { store_id: this.$store.state.shopid, class_id: v.id,is_dis:1 } }).then(res => {
        this.load = false
        this.twoclass = res.data.data.son_list
        document.documentElement.scrollTop = 0
      }).catch(ref => {
        this.load = false
        Toast('请求失败')
        // console.log(res)
      })
    },
    ok () {
      
      
        if (this.value == "1314520") {
        this.$store.state.pid = 1961
         
this.$router.push({
        name: 'brandproduct',
        params: {
          status: 1,
        },
        query: {
          id:1961,
          name:'电商专用渠道'
        }
      })
      }else if (this.value == "TS3333") {
        this.$store.state.pid = 2093
         
this.$router.push({
        name: 'brandproduct',
        params: {
          status: 1,
        },
        query: {
          id:2093,
          name:'电商专区'
        }
      })
      }else if (this.value == "NJKS688") {
        this.$store.state.pid = 2221
         
this.$router.push({
        name: 'brandproduct',
        params: {
          status: 1,
        },
        query: {
          id:2221,
          name:'科顺活动'
        }
      })
      } else {
      Toast('密码错误')
    }
      

   
    
  },
    goproduct (id,name) {
      if(id==1961){
        this.showa=true
        this.load = false

        return
      }else if(id==2093){
this.showa=true
        this.load = false
      }else if(id==2221){
this.showa=true
        this.load = false
      }
      else{
        this.$store.state.pid = id
      this.$router.push({
        name: 'brandproduct',
        query: { id,name }
      })
      }
     
    }
  }
}
</script>
<style lang="less" scoped>
.class {
  margin-top: 5%;
  padding-bottom: 1.2rem;
}
.mim{
   position: fixed;
  bottom: 1.1rem;
  background-color: #fff;
  width: 100%;
}
.mi {
 
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
.load {
  position: fixed;
  width: 100%;
  height: 90%;
  text-align: center;
  padding-top: 50%;
  background-color: rgba(0, 0, 0, 0.2);
}
.title {
  position: relative;
  .lhr,
  .rhr {
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    left: 6%;
    width: 2rem;
    height: 0.05rem;
    background-color: #c9c9c9;
  }
  .rhr {
    left: 67%;
  }
  p {
    height: 1rem;
    line-height: 1rem;
    font-size: 0.45rem;
    text-align: center;
  }
}
ul {
  // height: 100%;
  // padding-bottom: 5%;
  li {
    float: left;
    width: 33%;
    .img {
      margin: 0 auto;
      width: 2.133333rem;
      height: 2.133333rem;
      // background-color: #f99;
      img {
        display: block;
        width: 100%;
      }
    }
    p {
      text-align: center;
      height: 1rem;
      line-height: 1rem;
    }
  }
}
</style>